export interface SseMessage {
  event: string;
  data: string;
}

/**
 * Split buffered text/event-stream data into complete events, returning the
 * unfinished tail to prepend to the next chunk. e.g.
 *   'event: token\ndata: {"text":"Hi"}\n\nevent: tok'
 *   -> events [{event: 'token', data: '{"text":"Hi"}'}], rest 'event: tok'
 */
export function parseSseChunk(buffer: string): { events: SseMessage[]; rest: string } {
  const blocks = buffer.replace(/\r\n/g, '\n').split('\n\n');
  const rest = blocks.pop() ?? '';
  const events: SseMessage[] = [];
  for (const block of blocks) {
    let event = 'message';
    const data: string[] = [];
    for (const line of block.split('\n')) {
      if (line.startsWith('event:')) event = line.slice(6).trim();
      else if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
    }
    if (data.length) events.push({ event, data: data.join('\n') });
  }
  return { events, rest };
}
